import { useNavigate } from 'react-router-dom'

export const useGoToScanContainer = () => {
  const navigate = useNavigate()

  return {
    go: (location) => {
      navigate(SCAN_CONTAINER.replace(':location', location))
    }
  }
}

export const SCAN_CONTAINER = '/inventory-fix/scan-container/:location'
